<template>
  <div class="fixed right-0 z-30 top-14 w-full md:max-w-lg">
    <TransitionGroup>
      <ToastBar
        v-for="toast in toasts"
        :key="toast.id"
        :toast="toast"
      />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import ToastBar from '@/components/toast/ToastBar.vue'

defineProps<{
  toasts: Toast[]
}>()
</script>

<style>
.v-enter-active {
  transition: all 1s ease-in-out;
}
.v-leave-active {
  transition: all 0.5s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  transform: translate(110%);
}
</style>
